import styled from 'styled-components'
import { SkeletonElement, theme } from '@notino/react-styleguide'
import { NotinoLabelRegular, NotinoTitleMedium, resetButtonStyles } from '../../../../styles/helpers'
import { BREAKPOINTS, BREAKPOINTS_INTS } from '../../../../styles/constants'

const NOTINO_MODAL_DESKTOP_MARGIN = 5 // in rem7
// we need to add 1px while overriding styles because Notino components use max-width instead of min-widths
const BREAKPOINT = BREAKPOINTS_INTS.sm + 1

// NOTE: we need to override styles on Notino modal for which no better approach was found
export const ModalWrapper = styled.div`
	position: relative;

	> div > div {
		overflow-y: auto;
	}

	& div[role='dialog'] {
		position: relative;
		max-width: 100vw;

		& > button {
			display: none;
		}

		> div:first-of-type {
			height: 100%;
			max-height: initial;

			> div:first-of-type {
				height: 100%;

				> div:first-of-type {
					height: 100%;
				}
			}
		}

		@media (min-width: ${BREAKPOINT}px) {
			max-width: 500px;
			width: 100%;
			max-height: 720px;
			min-height: 400px;
			margin: ${NOTINO_MODAL_DESKTOP_MARGIN}rem auto;
			height: calc(100% - ${NOTINO_MODAL_DESKTOP_MARGIN * 2}rem);
			border-radius: 4px;
			overflow: hidden;
		}

		@media (min-width: ${BREAKPOINT} && max-height: ${BREAKPOINTS.md}) {
			margin: ${NOTINO_MODAL_DESKTOP_MARGIN / 2}rem auto;
			height: calc(100% - ${NOTINO_MODAL_DESKTOP_MARGIN}rem);
		}
	}
`

export const ModalContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	overflow: hidden;
`

export const ModalHeader = styled.header`
	${NotinoTitleMedium};
	display: flex;
	padding: 20px;
	align-items: center;
	justify-content: center;
	min-height: 72px;
	background: ${theme.color.background.primary};
	position: relative;
`

export const CloseButton = styled.button`
	${resetButtonStyles};
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
`

export const ModalMain = styled.main`
	flex: 1;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
`

export const ElementsList = styled.ul`
	width: 100%;
`

export const ElementsListItem = styled.li`
	display: flex;
	align-items: center;
	padding: 16px 20px;
	gap: 10px;
	${NotinoLabelRegular}

	&:not(:last-of-type) {
		border-bottom: 1px solid ${theme.color.border.divider};
	}
`

export const ElementsListItemImageContainer = styled.div`
	width: 48px;
	height: 48px;

	img {
		aspect-ratio: 1;
		object-fit: contain;
		flex-shrink: 0;
		border-radius: 50%;
		display: block;
	}
`

export const SkeletonAvatarElement = styled(SkeletonElement)`
	border-radius: 50%;
`
